import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Divider,
  Alert,
  AlertTitle,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Cropper from "react-cropper";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";
import "../campus/Campus.css";
import { Dropdown } from "semantic-ui-react";
import "cropperjs/dist/cropper.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import useQuery from "hooks/useQuery";
import { ToastContainer, toast } from "react-toastify";
import is from "date-fns/esm/locale/is/index.js";
import { get } from "lodash";
import { quartersToYears } from "date-fns";
import { de } from "date-fns/locale";
import { IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import GetApplications from "../student_dashboard/Pages/GetApplications";
import InputMask from "react-input-mask";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const steps = ["Personal Information", "Academics Information"];

const AffiliateApplication = () => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem("token");
  const query = useQuery();
  const application_id = query.get("a");
  const application_type = query.get("type");

  const [all_campaigns, setAllCampaigns] = useState([]);
  const [all_departments, setAllDepartments] = useState([]);
  const [department_id, setDepartmentId] = useState();
  const [degree_id, setDegreeId] = useState();
  const [all_degrees, setAllDegrees] = useState([]);
  const [campaign_id, setCampaignId] = useState();
  const [cnic, setCnic] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [fatherOccupation, setFatherOccupation] = useState("");
  const [fatherIncome, setFatherIncome] = useState("");
  const [fatherCnic, setFatherCnic] = useState("");
  const [gender, setGender] = useState("");
  const [nationality, setNationality] = useState("");
  const [province, setProvince] = useState("");
  const [provincesList, setProvincesList] = useState([]);
  const [domicile, setDomicile] = useState("");
  const [citiesList, setCitiesList] = useState([]);
  const [religion, setReligion] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [telNo, setTelNo] = useState("");
  const [fatherCellNo, setFatherCellNo] = useState("");
  const [applicantCellNo, setApplicantCellNo] = useState("");
  const [hafizQuran, setHafizQuran] = useState(""); // Boolean default
  const [disability, setDisability] = useState("");
  const [applicantImage, setApplicantImage] = useState("");
  const [applicantCnicFront, setApplicantCnicFront] = useState("");
  const [applicantCnicBack, setApplicantCnicBack] = useState("");
  const [fatherCnicFront, setFatherCnicFront] = useState("");
  const [fatherCnicBack, setFatherCnicBack] = useState("");
  const [emergencyContactName, setEmergencyContactName] = useState("");
  const [emergencyContactCellNo, setEmergencyContactCellNo] = useState("");
  const [emergencyContactAddress, setEmergencyContactAddress] = useState("");
  const [maxPreferences, setMaxPreferences] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [academicErrors, setAcademicErrors] = useState([]);
  const [tempImage, setTempImage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [cropper, setCropper] = useState(null);
  const [currentField, setCurrentField] = useState("");
  const fileInputRefs = {
    applicantImage: useRef(null),
    applicantCnicFront: useRef(null),
    applicantCnicBack: useRef(null),
    fatherCnicFront: useRef(null),
    fatherCnicBack: useRef(null),
  };
  const [degrees, setDegrees] = useState([]);
  const [selectedDegrees, setSelectedDegrees] = useState([]);
  const [tests, setTests] = useState([]);
  const [testErrors, setTestErrors] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [previousPrograms, setPreviousPrograms] = useState([]);
  const [programLoading, setProgramLoading] = useState(false);
  const [all_quotas, setAllQuotas] = useState([]);
  const [quota_id, setQuotaId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
    guidance: [],
    voucherToken: "",
  });

  const [academics, setAcademics] = useState(() => [
    {
      type: "matric",
      exam_system: "Annual",
      degree: "",
      board: "",
      year: "",
      roll_no: "",
      total_marks: "",
      obtain_marks: "",
      division: "",
      grade: "",
      percentage: "",
      result: "",
    },
    {
      type: "inter",
      exam_system: "Annual",
      degree: "",
      board: "",
      year: "",
      roll_no: "",
      total_marks: "",
      obtain_marks: "",
      division: "",
      exam_pass_in: "",
      grade: "",
      percentage: "",
      result: "",
    },
    {
      type: "bsc",
      exam_system: "Annual",
      degree: "",
      board: "",
      year: "",
      roll_no: "",
      total_marks: "",
      obtain_marks: "",
      division: "",
      exam_pass_in: "",
      grade: "",
      percentage: "",
      result: "",
    },
    {
      type: "ma",
      exam_system: "Annual",
      degree: "",
      board: "",
      year: "",
      roll_no: "",
      total_marks: "",
      obtain_marks: "",
      division: "",
      exam_pass_in: "",
      grade: "",
      percentage: "",
      position: "",
      result: "",
    },
    {
      type: "bs",
      exam_system: "Annual",
      degree: "",
      board: "",
      year: "",
      roll_no: "",
      total_marks: "",
      obtain_marks: "",
      division: "",
      exam_pass_in: "",
      grade: "",
      percentage: "",
      position: "",
      result: "",
    },
    {
      type: "mphil",
      exam_system: "Annual",
      degree: "",
      board: "",
      year: "",
      roll_no: "",
      total_marks: "",
      obtain_marks: "",
      division: "",
      grade: "",
      percentage: "",
      position: "",
      result: "",
    },
  ]);

  const qualifications = ["matric", "inter", "bsc", "ma", "mphil", "bs"];

  // const [addedQualifications, setAddedQualifications] = useState([]);

  // const handleAddQualification = (type) => {
  //     if (!addedQualifications.includes(type)) {
  //         setAddedQualifications([...addedQualifications, type]);
  //         setAcademics([...academics, { type }]); // Add a new academic entry
  //     }
  // };

  // const handleAcademicChange = (index, field, value) => {
  //     const newAcademics = [...academics];
  //     newAcademics[index][field] = value;
  //     setAcademics(newAcademics);
  // };

  const [addedQualifications, setAddedQualifications] = useState(["matric"]); // Start with Matric already added

  const handleAddQualification = (type) => {
    if (!addedQualifications.includes(type)) {
      setAddedQualifications([...addedQualifications, type]);
    }
  };

  const handleRemoveQualification = (type) => {
    // Remove the qualification type from addedQualifications
    setAddedQualifications(addedQualifications.filter((q) => q !== type));

    // Reset the corresponding academic entry
    setAcademics((prevAcademics) =>
      prevAcademics.map((academic) =>
        academic.type === type ? getDefaultAcademicEntry(type) : academic
      )
    );

    // Re-validate the form after removing a qualification
    handleValidation();
  };

  // Function to get the default academic entry for a given type
  const getDefaultAcademicEntry = (type) => {
    return {
      type: type,
      exam_system: "Annual",
      degree: "",
      board: "",
      year: "",
      roll_no: "",
      total_marks: "",
      obtain_marks: "",
      division: "",
      grade: "",
      percentage: "",
      result: "",
    };
  };

  const handleAcademicChange = (index, field, value) => {
    const newAcademics = [...academics];
    newAcademics[index][field] = value;
    setAcademics(newAcademics);
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/submit_application/get_cities_by_state/${province}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data && data.cities) {
          setCitiesList(data.cities);
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    if (province) {
      fetchCities();
    }
  }, [province, BASE_URL, token]);

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/submit_application/get_states`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data && data.states) {
          setProvincesList(data.states);
        }
      } catch (error) {
        console.error("Error fetching provinces:", error);
      }
    };

    fetchProvinces();
  }, [BASE_URL, token]);

  const getSixteenYearsBack = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 16);
    return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  // const handleAcademicChange = (index, field, value) => {
  //     const updatedAcademics = [...academics];
  //     updatedAcademics[index][field] = value;
  //     setAcademics(updatedAcademics);
  // };

  // Handle image selection
  const handleImageChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setTempImage(reader.result);
        setCurrentField(field);
        setOpenDialog(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePlaceholderClick = (field) => {
    fileInputRefs[field].current.click();
  };

  const cropImage = () => {
    if (cropper) {
      const croppedImage = cropper.getCroppedCanvas().toDataURL();
      switch (currentField) {
        case "applicantImage":
          setApplicantImage(croppedImage);
          break;
        case "applicantCnicFront":
          setApplicantCnicFront(croppedImage);
          break;
        case "applicantCnicBack":
          setApplicantCnicBack(croppedImage);
          break;
        case "fatherCnicFront":
          setFatherCnicFront(croppedImage);
          break;
        case "fatherCnicBack":
          setFatherCnicBack(croppedImage);
          break;
        default:
          break;
      }
      setOpenDialog(false);
    }
  };

  const validateStep1 = () => {
    let errors = {};

    // Helper to safely handle undefined values
    const safeValue = (value) => (value || "").toString();

    // Validate CNIC
    if (!safeValue(cnic)) {
      errors.cnic = "CNIC is required.";
    }

    // Validate Name
    if (!safeValue(campaign_id)) {
      errors.campaign_id = "Campaign is required.";
    }
    if (!safeValue(department_id)) {
      errors.department_id = "Campaign is required.";
    }
    if (!safeValue(degree_id)) {
      errors.degree_id = "Campaign is required.";
    }
    if (!safeValue(quota_id)) {
      errors.quota_id = "Quota is required.";
    }
    if (!safeValue(name)) {
      errors.name = "Name is required.";
    }
    if (!safeValue(email)) {
      errors.email = "Email is required.";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(safeValue(email))
    ) {
      errors.email = "Invalid email format.";
    }
    // Validate Date of Birth
    if (!safeValue(dateOfBirth)) {
      errors.dateOfBirth = "Date of Birth is required.";
    }

    // Validate Father Name
    if (!safeValue(fatherName)) {
      errors.fatherName = "Father Name is required.";
    }

    // Validate Father Occupation
    if (!safeValue(fatherOccupation)) {
      errors.fatherOccupation = "Father/Guardian Occupation is required.";
    }

    // Validate Father Income
    if (!safeValue(fatherIncome) || isNaN(fatherIncome)) {
      errors.fatherIncome =
        "Father/Guardian Income is required and must be a number.";
    }

    // Validate Father CNIC
    if (!safeValue(fatherCnic)) {
      errors.fatherCnic = "Father/Guardian CNIC is required.";
    }

    // Validate Gender
    if (!safeValue(gender)) {
      errors.gender = "Gender is required.";
    }

    // Validate Nationality
    if (!safeValue(nationality)) {
      errors.nationality = "Nationality is required.";
    }

    // Validate Province
    if (!safeValue(province)) {
      errors.province = "Province is required.";
    }

    // Validate Domicile
    if (!safeValue(domicile)) {
      errors.domicile = "Domicile is required.";
    }

    // Validate Religion
    if (!safeValue(religion)) {
      errors.religion = "Religion is required.";
    }

    // Validate Current Address
    if (!safeValue(currentAddress)) {
      errors.currentAddress = "Current Address is required.";
    }

    // Validate Permanent Address
    if (!safeValue(permanentAddress)) {
      errors.permanentAddress = "Permanent Address is required.";
    }

    // Validate Father Cell Number
    if (!safeValue(fatherCellNo)) {
      errors.fatherCellNo = "Father/Guardian Cell Number is required.";
    }

    // Validate Applicant Cell Number
    if (!safeValue(applicantCellNo)) {
      errors.applicantCellNo = "Applicant Cell Number is required.";
    }

    // Validate Hafiz Quran
    if (!safeValue(hafizQuran)) {
      errors.hafizQuran = "Hafiz e Quran selection is required.";
    }

    // Validate Emergency Contact Name
    if (!safeValue(emergencyContactName)) {
      errors.emergencyContactName = "Emergency Contact Name is required.";
    }

    // Validate Emergency Contact Cell Number
    if (!safeValue(emergencyContactCellNo)) {
      errors.emergencyContactCellNo =
        "Emergency Contact Cell Number is required.";
    }

    // Validate Emergency Contact Address
    if (!safeValue(emergencyContactAddress)) {
      errors.emergencyContactAddress = "Emergency Contact Address is required.";
    }

    // Validate Applicant Image
    if (!safeValue(applicantImage)) {
      errors.applicantImage = "Applicant Image is required.";
    }
    if (!safeValue(applicantCnicFront)) {
      errors.applicantCnicFront = "Applicant CNIC Front is required.";
    }
    if (!safeValue(fatherCnicFront)) {
      errors.fatherCnicFront = "Father/Guardian CNIC Front is required.";
    }
    if (!safeValue(fatherCnicBack)) {
      errors.fatherCnicBack = "Father/Guardian CNIC Back is required.";
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0; // Return true if no errors
  };

  // const submitStep1 = async () => {
  //     let data = {
  //         step: 1,
  //         application_id: application_id,
  //         cnic,
  //         date_of_birth: dateOfBirth,
  //         campaign_id: campaign_id,
  //         name,
  //         father_name: fatherName,
  //         father_occupation: fatherOccupation,
  //         father_income: fatherIncome,
  //         father_cnic: fatherCnic,
  //         gender,
  //         nationality,
  //         province,
  //         domicile,
  //         religion,
  //         current_address: currentAddress,
  //         permanent_address: permanentAddress,
  //         tel_no: telNo,
  //         father_cell_no: fatherCellNo,
  //         applicant_cell_no: applicantCellNo,
  //         hafiz_quran: hafizQuran === "Yes", // Convert to boolean
  //         disability: disability,
  //         applicant_image: applicantImage,
  //         applicant_cnic_front: applicantCnicFront,
  //         applicant_cnic_back: applicantCnicBack,
  //         father_cnic_front: fatherCnicFront,
  //         father_cnic_back: fatherCnicBack,
  //         emergency_contact_name: emergencyContactName,
  //         emergency_contact_cell_no: emergencyContactCellNo,
  //         emergency_contact_address: emergencyContactAddress,
  //     };
  //     // Log the data to the console (for debugging purposes)
  //     console.log("Simulated submission data:", data);

  //     // Simulate a delay to mimic an API call
  //     await new Promise((resolve) => setTimeout(resolve, 1000));

  //     // Return true to indicate success
  //     return true;
  // };

  const getPreviousPrograms = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(
      `${BASE_URL}/submit_application/get_previous_programs`,
      requestOptions
    );
    const result = await response.json();
    if (result.previous_programs) {
      setPreviousPrograms(result.previous_programs);
    }
  };

  const getUniversities = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(
      `${BASE_URL}/submit_application/get_previous_universities`,
      requestOptions
    );
    const result = await response.json();
    if (result.previous_universities) {
      setUniversities(result.previous_universities);
    }
  };

  const validateAcademics = (academicsList, addedTypes) => {
    const errors = [];
    academicsList.forEach((academic, index) => {
      if (!addedTypes.includes(academic.type)) {
        return;
      }
      const error = {};
      if ("degree" in academic && !academic.degree) {
        error.degree = "Degree is required.";
      }

      if ("board" in academic && !academic.board) {
        error.board = "Board is required.";
      }

      if ("year" in academic && !academic.year) {
        error.year = "Year is required.";
      }

      if ("roll_no" in academic && !academic.roll_no) {
        error.roll_no = "Roll number is required.";
      }

      if ("total_marks" in academic && !academic.total_marks) {
        error.total_marks = "Total marks are required.";
      } else if (isNaN(academic.total_marks)) {
        error.total_marks = "Total marks must be a number.";
      }

      if ("obtain_marks" in academic && !academic.obtain_marks) {
        error.obtain_marks = "Obtain marks are required.";
      } else if (isNaN(academic.obtain_marks)) {
        error.obtain_marks = "Obtain marks must be a number.";
      }

      if ("division" in academic && !academic.division) {
        error.division = "Division is required.";
      }

      if ("exam_pass_in" in academic && !academic.exam_pass_in) {
        error.exam_pass_in = "Exam pass type is required.";
      }

      if ("grade" in academic && !academic.grade) {
        error.grade = "Grade is required.";
      }

      if (
        "percentage" in academic &&
        !academic.percentage &&
        academic.exam_system === "Semester"
      ) {
        error.percentage = "Percentage is required.";
      }

      if ("major_subject" in academic && !academic.major_subject) {
        error.major_subject = "Major subject is required.";
      }
      if ("result" in academic && !academic.result) {
        error.result = "Result Attachment is required.";
      }
      if (Object.keys(error).length > 0) {
        errors[index] = error;
      }
    });
    return errors;
  };

  const handleValidation = () => {
    const validationErrors = validateAcademics(
      academics,
      addedQualifications
    );

    setAcademicErrors(validationErrors);

    return validationErrors.filter(Boolean).length === 0;
  };

  const closeFeedbackModal = () => {
    setFeedbackModal((prev) => ({ ...prev, open: false }));
  };

  const showFeedbackModal = ({
    type,
    title,
    message,
    guidance = [],
    voucherToken = "",
  }) => {
    setFeedbackModal({
      open: true,
      type,
      title,
      message,
      guidance,
      voucherToken,
    });
  };

  const getErrorGuidance = (errorText = "") => {
    const text = String(errorText || "").toLowerCase();

    if (text.includes("email already exists")) {
      return [
        "This email is already registered in the system.",
        "Go back to Personal Information and enter a different unused email, then submit again.",
        "If this student already has an account, search them by CNIC instead of creating a duplicate re-admission.",
      ];
    }
    if (text.includes("cnic already exists") || text.includes("cnic already")) {
      return [
        "This CNIC is already registered.",
        "Verify the CNIC is typed correctly (13 digits with dashes).",
        "If the student already exists, use their existing record instead of creating a duplicate application.",
      ];
    }
    if (text.includes("phone") && text.includes("exist")) {
      return [
        "This mobile number is already registered.",
        "Use a different applicant cell number, or find the existing student record and continue from there.",
      ];
    }
    if (text.includes("fee structure")) {
      return [
        "No admission fee structure is defined for the selected program in this campaign.",
        "Add the program fee under Fee Structure for this campaign, then submit the form again.",
      ];
    }
    if (
      text.includes("program") &&
      (text.includes("not found") || text.includes("required"))
    ) {
      return [
        "Go back to Personal Information and select a valid Campaign, Department, and Program.",
      ];
    }
    if (text.includes("quota")) {
      return [
        "Go back to Personal Information and select a valid quota for the chosen program.",
      ];
    }
    if (text.includes("campaign")) {
      return [
        "Go back to Personal Information and select a valid campaign.",
      ];
    }
    if (text.includes("already exists")) {
      return [
        "A student with this CNIC, email, or phone number already exists.",
        "Check the CNIC, email, and cell number on Personal Information.",
        "If the student already has an account, use that record instead of creating a duplicate re-admission.",
      ];
    }
    if (text.includes("failed to retrieve user")) {
      return [
        "The student account could not be created.",
        "Check that the email is valid and not already in use, then try again.",
        "If the issue continues, contact IT support.",
      ];
    }
    if (
      text.includes("failed to fetch") ||
      text.includes("network") ||
      text.includes("an error occurred while submitting")
    ) {
      return [
        "Check your internet connection and try submitting again.",
        "If the problem continues, refresh the page and resubmit.",
      ];
    }
    return [
      "Review the error above and correct the highlighted fields on the form.",
      "Make sure all required personal and academic information is complete, including result documents.",
      "If the problem continues after correcting the data, contact IT support with this error message.",
    ];
  };

  const collectAcademicErrorMessages = (errors) => {
    const messages = [];
    errors.forEach((error, index) => {
      if (!error) return;
      const typeLabel = (academics[index]?.type || `qualification ${index + 1}`)
        .replace("_", " ")
        .toUpperCase();
      Object.values(error).forEach((msg) => {
        messages.push(`${typeLabel}: ${msg}`);
      });
    });
    return messages;
  };

  // const submitAcademics = async () => {
  //     setProgramLoading(true);
  //     let data = {
  //         step: 2,
  //         application_id: application_id,
  //         academics: academics,
  //     };

  //     // Log the data to the console (for debugging purposes)
  //     console.log("Simulated academics submission data:", data);

  //     // Simulate a delay to mimic an API call
  //     await new Promise((resolve) => setTimeout(resolve, 1000));

  //     // Simulate a successful response
  //     const result = { success: true, error: "Academics submitted successfully." };

  //     // Show success message
  //     toast.success(result.error);

  //     if (result.success) {
  //         setSelectedDegrees([]);
  //         await getDegreesInCampaign(); // Assuming this function does not require an API call
  //         return true;
  //     }

  //     return false;
  // };

  const prepareSubmissionData = () => {
    return {
      application_id: application_id,
      personal_info: {
        cnic,
        date_of_birth: dateOfBirth,
        campaign_id,
        name,
        email,
        father_name: fatherName,
        father_occupation: fatherOccupation,
        father_income: fatherIncome,
        father_cnic: fatherCnic,
        gender,
        nationality,
        province,
        domicile,
        religion,
        current_address: currentAddress,
        permanent_address: permanentAddress,
        tel_no: telNo,
        father_cell_no: fatherCellNo,
        applicant_cell_no: applicantCellNo,
        hafiz_quran: hafizQuran === "Yes", // Convert to boolean
        disability,
        applicant_image: applicantImage,
        applicant_cnic_front: applicantCnicFront,
        applicant_cnic_back: applicantCnicBack,
        father_cnic_front: fatherCnicFront,
        father_cnic_back: fatherCnicBack,
        emergency_contact_name: emergencyContactName,
        emergency_contact_cell_no: emergencyContactCellNo,
        emergency_contact_address: emergencyContactAddress,
      },
      academics: academics,
    };
  };

  const submitAffiliateApplicant = async () => {
    setLoading(true);

    const filteredAcademics = academics.filter((academic) =>
      addedQualifications.includes(academic.type)
    );

    const data = {
      campaign_id: campaign_id,
      program_id: degree_id,
      quota_id: Number(quota_id),
      cnic,
      date_of_birth: dateOfBirth,
      name,
      email,
      father_name: fatherName,
      father_occupation: fatherOccupation,
      father_income: Number(fatherIncome), // Ensure this is a number
      father_cnic: fatherCnic,
      gender,
      nationality,
      province,
      domicile,
      religion,
      current_address: currentAddress,
      permanent_address: permanentAddress,
      tel_no: telNo,
      father_cell_no: fatherCellNo,
      applicant_cell_no: applicantCellNo,
      hafiz_quran: hafizQuran,
      disability,
      applicant_image: applicantImage,
      applicant_cnic_front: applicantCnicFront,
      applicant_cnic_back: applicantCnicBack,
      father_cnic_front: fatherCnicFront,
      father_cnic_back: fatherCnicBack,
      emergency_contact_name: emergencyContactName,
      emergency_contact_cell_no: emergencyContactCellNo,
      emergency_contact_address: emergencyContactAddress,
      academics: filteredAcademics.map((academic) => ({
        type: academic.type,
        degree: academic.degree,
        board: academic.board,
        year: Number(academic.year),
        roll_no: academic.roll_no,
        total_marks: Number(academic.total_marks),
        obtain_marks: Number(academic.obtain_marks),
        division: academic.division,
        exam_pass_in: academic.exam_pass_in,
        grade: academic.grade,
        percentage: Number(academic.percentage),
        major_subject: academic.major_subject,
        position: academic.position,
        elective_subject_one: academic.elective_subject_one,
        elective_subject_one_total_marks: Number(
          academic.elective_subject_one_total_marks
        ),
        elective_subject_one_obtain_marks: Number(
          academic.elective_subject_one_obtain_marks
        ),
        elective_subject_two: academic.elective_subject_two,
        elective_subject_two_total_marks: Number(
          academic.elective_subject_two_total_marks
        ),
        elective_subject_two_obtain_marks: Number(
          academic.elective_subject_two_obtain_marks
        ),
        elective_subject_three: academic.elective_subject_three,
        elective_subject_three_total_marks: Number(
          academic.elective_subject_three_total_marks
        ),
        elective_subject_three_obtain_marks: Number(
          academic.elective_subject_three_obtain_marks
        ),
        result: academic.result,
      })),
    };

    try {
      const response = await fetch(
        `${BASE_URL}/application/add_re_admission_application`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      let result = {};
      try {
        result = await response.json();
      } catch (parseError) {
        result = {};
      }
      const errorMessage =
        result.error ||
        result.message ||
        result.detail ||
        (response.ok
          ? ""
          : "Submission failed. Please review the form and try again.");

      if (response.ok && (result.success || result.voucher_token)) {
        showFeedbackModal({
          type: "success",
          title: "Application Submitted",
          message:
            typeof result.success === "string"
              ? result.success
              : "Re-admission application submitted successfully.",
          guidance: [
            "A fee voucher has been generated for this application.",
            "Use Open Fee Voucher to print or share the voucher with the student.",
            "You can submit another re-admission from the form after closing this message.",
          ],
          voucherToken: result.voucher_token || "",
        });
        if (result.voucher_token) {
          window.open(
            `/admissions/fee-voucher/${result.voucher_token}`,
            "_blank"
          );
        }
        return true;
      }

      showFeedbackModal({
        type: "error",
        title: "Submission Failed",
        message: errorMessage,
        guidance: getErrorGuidance(errorMessage),
      });
      return false;
    } catch (error) {
      const errorMessage =
        error?.message ||
        "An error occurred while submitting the application.";
      showFeedbackModal({
        type: "error",
        title: "Submission Failed",
        message: errorMessage,
        guidance: getErrorGuidance(errorMessage),
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleNext = async () => {
    if (activeStep === 0) {
      if (!validateStep1()) {
        showFeedbackModal({
          type: "error",
          title: "Personal Information Incomplete",
          message:
            "Some required personal information is missing or invalid.",
          guidance: [
            "Complete every field marked with a red asterisk (*).",
            "Correct the fields highlighted in red, then click Next again.",
            "Make sure CNIC, email, photos, and contact numbers are filled in correctly.",
          ],
        });
        return;
      }
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 1) {
      if (!handleValidation()) {
        const fieldErrors = collectAcademicErrorMessages(
          validateAcademics(academics, addedQualifications)
        );
        showFeedbackModal({
          type: "error",
          title: "Academic Information Incomplete",
          message:
            fieldErrors[0] ||
            "Some required academic fields are missing or invalid.",
          guidance: [
            ...fieldErrors.slice(0, 8),
            "Upload a result card for each qualification (PNG, JPEG, JPG, or PDF, max 2 MB).",
            "If a document is already attached, click View to preview it, or choose a new file to replace it.",
            "Correct the fields highlighted in red, then click Finish again.",
          ],
        });
        return;
      }
      const success = await submitAffiliateApplicant();
      if (success) {
        setActiveStep(steps.length);
      }
    }
  };

  const getDegreesInCampaign = async () => {
    setProgramLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/submit_application/get_degrees_in_campaign/${application_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const jsonData = await response.json();
      const degrees = jsonData.degrees;
      setDegrees(degrees);
      setProgramLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleBack = () => {
    if (activeStep === 3) {
      getDegreesInCampaign();
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0); // Reset to the first step
    // Reset all form fields to their initial values
    setCnic("");
    setDateOfBirth("");
    setName("");
    setFatherName("");
    setFatherOccupation("");
    setFatherIncome("");
    setFatherCnic("");
    setGender("");
    setNationality("");
    setProvince("");
    setDomicile("");
    setReligion("");
    setCurrentAddress("");
    setPermanentAddress("");
    setTelNo("");
    setFatherCellNo("");
    setApplicantCellNo("");
    setHafizQuran("");
    setDisability("");
    setApplicantImage("");
    setApplicantCnicFront("");
    setApplicantCnicBack("");
    setFatherCnicFront("");
    setFatherCnicBack("");
    setEmergencyContactName("");
    setEmergencyContactCellNo("");
    setEmergencyContactAddress("");
    setMaxPreferences("");

    setFormErrors({});
    setAcademicErrors([]);
    setAddedQualifications(["matric"]); // Reset added qualifications if needed
    setAcademics(() => [
      {
        type: "matric",
        exam_system: "Annual",
        degree: "",
        board: "",
        year: "",
        roll_no: "",
        total_marks: "",
        obtain_marks: "",
        division: "",
        grade: "",
        percentage: "",
        result: "",
      },
      {
        type: "inter",
        exam_system: "Annual",
        degree: "",
        board: "",
        year: "",
        roll_no: "",
        total_marks: "",
        obtain_marks: "",
        division: "",
        exam_pass_in: "",
        grade: "",
        percentage: "",
        result: "",
      },
      {
        type: "bsc",
        exam_system: "Annual",
        degree: "",
        board: "",
        year: "",
        roll_no: "",
        total_marks: "",
        obtain_marks: "",
        division: "",
        exam_pass_in: "",
        grade: "",
        percentage: "",
        result: "",
      },
      {
        type: "ma",
        exam_system: "Annual",
        degree: "",
        board: "",
        year: "",
        roll_no: "",
        total_marks: "",
        obtain_marks: "",
        division: "",
        exam_pass_in: "",
        grade: "",
        percentage: "",
        position: "",
        result: "",
      },
      {
        type: "bs",
        exam_system: "Annual",
        degree: "",
        board: "",
        year: "",
        roll_no: "",
        total_marks: "",
        obtain_marks: "",
        division: "",
        exam_pass_in: "",
        grade: "",
        percentage: "",
        position: "",
        result: "",
      },
      {
        type: "mphil",
        exam_system: "Annual",
        degree: "",
        board: "",
        year: "",
        roll_no: "",
        total_marks: "",
        obtain_marks: "",
        division: "",
        grade: "",
        percentage: "",
        position: "",
        result: "",
      },
    ]);
    setCampaignId();
    setDepartmentId(); // or setDepartmentId("");
    setDegreeId();
  };

  const getSubjects = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await fetch(
      `${BASE_URL}/submit_application/get_previous_subjects`,
      requestOptions
    );
    const result = await response.json();
    if (result.previous_subjects) {
      setSubjects(result.previous_subjects);
    }
  };

  useEffect(() => {
    // getApplication();
    getSubjects();
    getUniversities();
    getPreviousPrograms();
  }, [application_id]);

  const getAllCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllCampaigns(data.campaigns);
      })
      .catch((error) => console.log(error));
  };

  const getDepartments = async (campaign_id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      BASE_URL + `/department/get_departments_by_campaign/${campaign_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };

  const getPrograms = async (department_id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(
      BASE_URL +
        `/degree/get_degrees_by_department/${department_id}?campaign_id=${campaign_id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setAllDegrees(data.degrees);
      })
      .catch((error) => console.log(error));
  };

  const getQuotas = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(BASE_URL + `/quota/get_quotas`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setAllQuotas(data.quotas);
      })
      .catch((error) => console.log(error));
  };

  const handleCampaign = (value) => {
    setCampaignId(value);
    getDepartments(value);
  };

  const handleProgram = (value) => {
    setDegreeId(value);
    getQuotas();
  };
  const handleQuota = (value) => {
    setQuotaId(value);
  };

  const handleDepartment = (value) => {
    setDepartmentId(value);
    getPrograms(value);
  };

  useEffect(() => {
    getAllCampaigns();
    getDepartments();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="mb-3">
        <ToastContainer />
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
          {/* <ApplicationBar title="BZU Application Form" /> */}
          <Box>
            <Stepper activeStep={activeStep} style={{ padding: "30px" }}>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {activeStep === steps.length ? (
              <Box sx={{ mt: 4 }}>
                <Typography variant="h6" align="center">
                  All steps completed – you are finished!
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </Box>
            ) : (
              <Box sx={{ mt: 4 }}>
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress sx={{ color: "blue" }} />
                  </Box>
                ) : (
                  <>
                    <Typography variant="h4">{steps[activeStep]}</Typography>
                    <Box sx={{ mt: 2 }}>
                      {activeStep === 0 && (
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Campaign <span className="text-danger"> *</span>
                              </label>
                              <Select
                                id="campaign_id"
                                name="campaign_id"
                                placeholder="Select Campaign"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                value={all_campaigns
                                  .map((camp) => ({
                                    label: camp.name,
                                    value: camp.id,
                                  }))
                                  .find(
                                    (option) => option.value === campaign_id
                                  )}
                                onChange={(selectedOption) =>
                                  handleCampaign(selectedOption.value)
                                }
                                options={all_campaigns.map((camp) => ({
                                  label: camp.name,
                                  value: camp.id,
                                }))}
                                isSearchable
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.campaign_id}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label htmlFor="filter_department_id">
                                Department{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <Select
                                id="filter_department_id"
                                name="filter_department_id"
                                placeholder="Select Department"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                value={all_departments
                                  .map((dep) => ({
                                    label: dep.name,
                                    value: dep.id,
                                  }))
                                  .find(
                                    (option) => option.value === department_id
                                  )}
                                onChange={(selectedOption) =>
                                  handleDepartment(selectedOption.value)
                                }
                                options={all_departments.map((dep) => ({
                                  label: dep.name,
                                  value: dep.id,
                                }))}
                                isSearchable
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.department_id}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label htmlFor="filter_degree_id">
                                Programs <span className="text-danger"> *</span>
                              </label>
                              <Select
                                id="filter_degree_id"
                                name="filter_degree_id"
                                placeholder="Select Program"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                value={all_degrees
                                  .map((degree) => ({
                                    label: degree.name,
                                    value: degree.id,
                                  }))
                                  .find((option) => option.value === degree_id)}
                                onChange={(selectedOption) =>
                                  handleProgram(selectedOption.value)
                                }
                                options={all_degrees.map((degree) => ({
                                  label: degree.name,
                                  value: degree.id,
                                }))}
                                isSearchable
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.degree_id}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label htmlFor="filter_quota_id">
                                Quotas <span className="text-danger"> *</span>
                              </label>
                              <Select
                                id="filter_quota_id"
                                name="filter_quota_id"
                                placeholder="Select Quota"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                value={all_quotas
                                  .map((quota) => ({
                                    label: quota.name,
                                    value: quota.id,
                                  }))
                                  .find((option) => option.value === quota_id)}
                                onChange={(selectedOption) =>
                                  handleQuota(selectedOption.value)
                                }
                                options={all_quotas.map((quota) => ({
                                  label: quota.name,
                                  value: quota.id,
                                }))}
                                isSearchable
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.quota_id}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                CNIC
                                <span className="text-danger"> *</span>
                              </label>
                              <InputMask
                                mask="99999-9999999-9"
                                name="cnic"
                                placeholder="CNIC"
                                value={cnic}
                                onChange={(e) => setCnic(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.cnic}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Name
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="name"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.name}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Email
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.email}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label
                              style={{ marginTop: "17px", marginLeft: "20px" }}
                            >
                              Applicant Image
                              <span className="text-danger"> *</span>
                            </label>
                            <div className="form-outline mt-3">
                              <img
                                src={applicantImage || "placeholder.jpg"}
                                alt="Applicant"
                                onClick={() =>
                                  handlePlaceholderClick("applicantImage")
                                }
                                style={{
                                  width: "50%",
                                  height: "auto",
                                  cursor: "pointer",
                                  border: "2px dashed #ccc",
                                  borderRadius: "8px",
                                }}
                              />
                              <input
                                type="file"
                                ref={fileInputRefs.applicantImage}
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageChange(e, "applicantImage")
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.applicantImage}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label
                              style={{ marginTop: "17px", marginLeft: "20px" }}
                            >
                              Applicant CNIC / B-Form Front
                              <span className="text-danger"> *</span>
                            </label>
                            <div className="form-outline mt-3">
                              <img
                                src={applicantCnicFront || "image_picker.png"}
                                alt="CNIC Front"
                                onClick={() =>
                                  handlePlaceholderClick("applicantCnicFront")
                                }
                                style={{
                                  width: "90%",
                                  height: "auto",
                                  cursor: "pointer",
                                  borderRadius: "8px",
                                  border: "2px dashed #ccc",
                                }}
                              />
                              <input
                                type="file"
                                ref={fileInputRefs.applicantCnicFront}
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageChange(e, "applicantCnicFront")
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.applicantCnicFront}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label
                              style={{ marginTop: "17px", marginLeft: "20px" }}
                            >
                              Applicant CNIC /B-Form Back
                              <span className="text-danger"> *</span>
                            </label>
                            <div className="form-outline mt-3">
                              <img
                                src={applicantCnicBack || "image_picker.png"}
                                alt="CNIC Back"
                                onClick={() =>
                                  handlePlaceholderClick("applicantCnicBack")
                                }
                                style={{
                                  width: "90%",
                                  height: "auto",
                                  cursor: "pointer",
                                  border: "2px dashed #ccc",
                                  borderRadius: "8px",
                                }}
                              />
                              <input
                                type="file"
                                ref={fileInputRefs.applicantCnicBack}
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageChange(e, "applicantCnicBack")
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.applicantCnicBack}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Date of Birth
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="date"
                                name="dateOfBirth"
                                value={dateOfBirth}
                                max={getSixteenYearsBack()}
                                onChange={(e) => setDateOfBirth(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.dateOfBirth}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Father Name
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="fatherName"
                                placeholder="Father Name"
                                value={fatherName}
                                onChange={(e) => setFatherName(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.fatherName}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Father/Guardian Occupation
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="fatherOccupation"
                                placeholder="Father/Guardian Occupation"
                                value={fatherOccupation}
                                onChange={(e) =>
                                  setFatherOccupation(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.fatherOccupation}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Father/Guardian Income
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="number"
                                name="fatherIncome"
                                placeholder="Father/Guardian Income"
                                value={fatherIncome}
                                onChange={(e) =>
                                  setFatherIncome(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.fatherIncome}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Father/Guardian CNIC
                                <span className="text-danger"> *</span>
                              </label>
                              <InputMask
                                mask="99999-9999999-9"
                                name="fatherCnic"
                                placeholder="Father/Guardian CNIC"
                                value={fatherCnic}
                                onChange={(e) => setFatherCnic(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.fatherCnic}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label
                              style={{ marginTop: "17px", marginLeft: "20px" }}
                            >
                              Father/Guardian CNIC Front
                              <span className="text-danger"> *</span>
                            </label>
                            <div className="form-outline mt-3">
                              <img
                                src={fatherCnicFront || "image_picker.png"}
                                alt="Father/Guardian CNIC Front"
                                onClick={() =>
                                  handlePlaceholderClick("fatherCnicFront")
                                }
                                style={{
                                  width: "90%",
                                  height: "auto",
                                  cursor: "pointer",
                                  border: "2px dashed #ccc",
                                  borderRadius: "8px",
                                }}
                              />
                              <input
                                type="file"
                                ref={fileInputRefs.fatherCnicFront}
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageChange(e, "fatherCnicFront")
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.fatherCnicFront}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label
                              style={{ marginTop: "17px", marginLeft: "20px" }}
                            >
                              Father/Guardian CNIC Back
                              <span className="text-danger"> *</span>
                            </label>
                            <div className="form-outline mt-3">
                              <img
                                src={fatherCnicBack || "image_picker.png"}
                                alt="Father CNIC Back"
                                onClick={() =>
                                  handlePlaceholderClick("fatherCnicBack")
                                }
                                style={{
                                  width: "90%",
                                  height: "auto",
                                  cursor: "pointer",
                                  border: "2px dashed #ccc",
                                  borderRadius: "8px",
                                }}
                              />
                              <input
                                type="file"
                                ref={fileInputRefs.fatherCnicBack}
                                accept="image/*"
                                onChange={(e) =>
                                  handleImageChange(e, "fatherCnicBack")
                                }
                                style={{ display: "none" }}
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.fatherCnicBack}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Gender
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                name="gender"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                            <div className="error-message1">
                              {formErrors.gender}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Nationality
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                name="nationality"
                                value={nationality}
                                onChange={(e) => setNationality(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              >
                                <option value="">Select Nationality</option>
                                <option value="Pakistani">Pakistani</option>
                                <option value="Overseas">Overseas</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                            <div className="error-message1">
                              {formErrors.nationality}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Province
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                name="province"
                                value={province}
                                onChange={(e) => setProvince(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              >
                                <option value="">Select Province</option>
                                {provincesList.map((prov) => (
                                  <option key={prov.id} value={prov.name}>
                                    {prov.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="error-message1">
                              {formErrors.province}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Domicile
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                name="domicile"
                                value={domicile}
                                onChange={(e) => setDomicile(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              >
                                <option value="">Select Domicile</option>
                                {citiesList.map((city) => (
                                  <option key={city.id} value={city.name}>
                                    {city.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="error-message1">
                              {formErrors.domicile}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Religion
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                name="religion"
                                value={religion}
                                onChange={(e) => setReligion(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              >
                                <option value="">Select Religion</option>
                                <option value="Muslim">Muslim</option>
                                <option value="Non-Muslim">Non-Muslim</option>
                              </select>
                            </div>
                            <div className="error-message1">
                              {formErrors.religion}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Current Address
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="currentAddress"
                                placeholder="Current Address"
                                value={currentAddress}
                                onChange={(e) =>
                                  setCurrentAddress(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.currentAddress}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Permanent Address
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="permanentAddress"
                                placeholder="Permanent Address"
                                value={permanentAddress}
                                onChange={(e) =>
                                  setPermanentAddress(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.permanentAddress}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Telephone Number</label>
                              <input
                                type="tel"
                                name="telNo"
                                placeholder="Telephone Number"
                                value={telNo}
                                onChange={(e) => setTelNo(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.telNo}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Father/Guardian Cell Number
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="tel"
                                name="fatherCellNo"
                                placeholder="Father/Guardian Cell Number"
                                value={fatherCellNo}
                                onChange={(e) =>
                                  setFatherCellNo(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.fatherCellNo}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Applicant Cell Number
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="tel"
                                name="applicantCellNo"
                                placeholder="Applicants Cell Number"
                                value={applicantCellNo}
                                onChange={(e) =>
                                  setApplicantCellNo(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.applicantCellNo}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Hafiz e Quran
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                name="hafizQuran"
                                value={hafizQuran}
                                onChange={(e) => setHafizQuran(e.target.value)}
                                className="form-control form-control-lg"
                                required
                              >
                                <option value="">Select Hafiz e Quran</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                            <div className="error-message1">
                              {formErrors.hafizQuran}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>Enter Your disability (if you have)</label>
                              <input
                                type="text"
                                name="disability"
                                placeholder="Disability"
                                value={disability}
                                onChange={(e) => setDisability(e.target.value)}
                                className="form-control form-control-lg"
                              />
                            </div>
                          </div>
                          <div className="col-md-12 mt-3 mb-3">
                            <Typography variant="h4">
                              Emergency Contact Information
                            </Typography>
                          </div>
                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Emergency Contact Name
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="emergencyContactName"
                                placeholder="Emergency Contact Name"
                                value={emergencyContactName}
                                onChange={(e) =>
                                  setEmergencyContactName(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.emergencyContactName}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Emergency Contact Cell Number
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="tel"
                                name="emergencyContactCellNo"
                                placeholder="Emergency Contact Cell Number"
                                value={emergencyContactCellNo}
                                onChange={(e) =>
                                  setEmergencyContactCellNo(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.emergencyContactCellNo}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-outline mt-3">
                              <label>
                                Emergency Contact Address
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="emergencyContactAddress"
                                placeholder="Emergency Contact Address"
                                value={emergencyContactAddress}
                                onChange={(e) =>
                                  setEmergencyContactAddress(e.target.value)
                                }
                                className="form-control form-control-lg"
                                required
                              />
                            </div>
                            <div className="error-message1">
                              {formErrors.emergencyContactAddress}
                            </div>
                          </div>
                        </div>
                      )}

                      {activeStep === 1 && (
                        <div>
                          {qualifications
                            .filter((q) => !addedQualifications.includes(q)) // Only show qualifications that haven't been added
                            .map((qualification) => (
                              <button
                                key={qualification}
                                onClick={() =>
                                  handleAddQualification(qualification)
                                }
                                className="btn-qualification"
                              >
                                Add{" "}
                                {qualification.charAt(0).toUpperCase() +
                                  qualification.slice(1)}
                              </button>
                            ))}

                          <>
                            {academics.map(
                              (academic, index) =>
                                addedQualifications.includes(academic.type) && (
                                  <div
                                    className="row"
                                    key={academic.id || index}
                                  >
                                    <div className="col-md-12 mt-3 mb-3 text-center">
                                      {academic.type === "matric" && (
                                        <>
                                          <Typography variant="h5">
                                            Matric / O Level or Equivalent
                                            Detail
                                          </Typography>
                                          <Divider />
                                        </>
                                      )}
                                      {academic.type === "inter" && (
                                        <>
                                          <Typography variant="h5">
                                            F.A / F.Sc / ICS / D.Com / DBA / A
                                            Level or Equivalent
                                          </Typography>
                                          <Divider />
                                        </>
                                      )}
                                      {academic.type === "bs" && (
                                        <>
                                          <Typography variant="h5">
                                            BS/B.Sc Hons. 4 Years or Equivalent
                                          </Typography>
                                          <Divider />
                                        </>
                                      )}
                                      {academic.type === "mphil" && (
                                        <>
                                          <Typography variant="h5">
                                            M.Phil Detail
                                          </Typography>
                                          <Divider />
                                        </>
                                      )}
                                      {academic.type === "bsc" && (
                                        <>
                                          <Typography variant="h5">
                                            B.A / B.Sc / B.Com / BBA or
                                            Equivalent Detail
                                          </Typography>
                                          <Divider />
                                        </>
                                      )}
                                      {academic.type === "ma" && (
                                        <>
                                          <Typography variant="h5">
                                            M.A / M.Sc or Equivalent Detail
                                          </Typography>
                                          <Divider />
                                        </>
                                      )}
                                    </div>
                                    {"degree" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Degree
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <select
                                            name="degree"
                                            value={academic.degree || ""} // Safe access
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "degree",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="" disabled>
                                              Select Degree
                                            </option>
                                            {previousPrograms
                                              .filter(
                                                (program) =>
                                                  program.type === academic.type
                                              )
                                              .map((program) => (
                                                <option
                                                  key={program.id}
                                                  value={program.name}
                                                >
                                                  {program.name}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]?.degree ||
                                            ""}
                                        </div>
                                      </div>
                                    )}
                                    {"exam_system" in academic &&
                                      academic.type !== "matric" &&
                                      academic.type !== "inter" && (
                                        <div className="col-md-4">
                                          <div className="form-outline mt-3">
                                            <label>
                                              Exam System
                                              <span className="text-danger">
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            <select
                                              name="exam_system"
                                              value={academic.exam_system || ""} // Safe access
                                              onChange={(e) =>
                                                handleAcademicChange(
                                                  index,
                                                  "exam_system",
                                                  e.target.value
                                                )
                                              }
                                              className="form-control form-control-lg"
                                              required
                                            >
                                              <option value="Annual">
                                                Annual System
                                              </option>
                                              <option value="Semester">
                                                Semester System
                                              </option>
                                            </select>
                                          </div>
                                          <div className="error-message1">
                                            {academicErrors?.[index]
                                              ?.exam_system || ""}{" "}
                                            {/* Safe access */}
                                          </div>
                                        </div>
                                      )}
                                    {"board" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Board / Institute{" "}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <select
                                            name="board"
                                            value={academic.board || ""} // Safe access
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "board",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="" disabled>
                                              Select Board / Institute
                                            </option>
                                            {universities
                                              .filter((university) =>
                                                academic.type === "matric" ||
                                                academic.type === "inter"
                                                  ? university.type === "board"
                                                  : university.type ===
                                                    "university"
                                              )
                                              .map((university) => (
                                                <option
                                                  key={university.id}
                                                  value={university.name}
                                                >
                                                  {university.name}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]?.board || ""}{" "}
                                          {/* Safe access */}
                                        </div>
                                      </div>
                                    )}
                                    {"year" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Year
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="number"
                                            name="year"
                                            placeholder="Year"
                                            value={academic.year || ""} // Safe access
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "year",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]?.year || ""}{" "}
                                          {/* Safe access */}
                                        </div>
                                      </div>
                                    )}
                                    {"roll_no" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Roll Number{" "}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            name="roll_no"
                                            placeholder="Roll Number"
                                            value={academic.roll_no || ""}
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "roll_no",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]?.roll_no ||
                                            ""}
                                        </div>
                                      </div>
                                    )}
                                    {"total_marks" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            {academic.exam_system === "Semester"
                                              ? "Total CGPA"
                                              : "Total Marks"}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="number"
                                            name="total_marks"
                                            placeholder={
                                              academic.exam_system ===
                                              "Semester"
                                                ? "Total CGPA"
                                                : "Total Marks"
                                            }
                                            value={academic.total_marks || ""}
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "total_marks",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]
                                            ?.total_marks || ""}
                                        </div>
                                      </div>
                                    )}
                                    {"obtain_marks" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            {academic.exam_system === "Semester"
                                              ? "Obtain CGPA"
                                              : "Obtain Marks"}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="number"
                                            name="obtain_marks"
                                            placeholder={
                                              academic.exam_system ===
                                              "Semester"
                                                ? "Obtain CGPA"
                                                : "Obtain Marks"
                                            }
                                            value={academic.obtain_marks || ""}
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "obtain_marks",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]
                                            ?.obtain_marks || ""}
                                        </div>
                                      </div>
                                    )}
                                    {"division" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Division{" "}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <select
                                            name="division"
                                            value={academic.division || ""}
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "division",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="" disabled>
                                              Select Division
                                            </option>
                                            <option value="1st">1st</option>
                                            <option value="2nd">2nd</option>
                                            <option value="3rd">3rd</option>
                                          </select>
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]?.division ||
                                            ""}
                                        </div>
                                      </div>
                                    )}
                                    {"exam_pass_in" in academic &&
                                      (academic.exam_system === "Annual" ||
                                        academic.type === "bsc" ||
                                        academic.type === "ma" ||
                                        academic.type === "bs") && (
                                        <div className="col-md-4">
                                          <div className="form-outline mt-3">
                                            <label>
                                              Exam Passed In{" "}
                                              <span className="text-danger">
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            <select
                                              name="exam_pass_in"
                                              value={
                                                academic.exam_pass_in || ""
                                              }
                                              onChange={(e) =>
                                                handleAcademicChange(
                                                  index,
                                                  "exam_pass_in",
                                                  e.target.value
                                                )
                                              }
                                              className="form-control form-control-lg"
                                              required
                                            >
                                              <option value="" disabled>
                                                Select Exam Type
                                              </option>
                                              <option value="Annual">
                                                Annual
                                              </option>
                                              <option value="Supply">
                                                Supply
                                              </option>
                                            </select>
                                          </div>
                                          <div className="error-message1">
                                            {academicErrors?.[index]
                                              ?.exam_pass_in || ""}
                                          </div>
                                        </div>
                                      )}
                                    {"grade" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Grade{" "}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <select
                                            name="grade"
                                            value={academic.grade || ""}
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "grade",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="" disabled>
                                              Select Grade
                                            </option>
                                            <option value="A+">A+</option>
                                            <option value="A">A</option>
                                            <option value="B+">B+</option>
                                            <option value="B">B</option>
                                            <option value="C+">C+</option>
                                            <option value="C">C</option>
                                            <option value="D+">D+</option>
                                            <option value="D">D</option>
                                          </select>
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]?.grade || ""}
                                        </div>
                                      </div>
                                    )}
                                    {"percentage" in academic &&
                                      academic.exam_system === "Semester" && (
                                        <div className="col-md-4">
                                          <div className="form-outline mt-3">
                                            <label>
                                              Percentage{" "}
                                              <span className="text-danger">
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            <input
                                              type="number"
                                              name="percentage"
                                              placeholder="Percentage"
                                              value={academic.percentage || ""}
                                              onChange={(e) =>
                                                handleAcademicChange(
                                                  index,
                                                  "percentage",
                                                  e.target.value
                                                )
                                              }
                                              className="form-control form-control-lg"
                                              required
                                            />
                                          </div>
                                          <div className="error-message1">
                                            {academicErrors?.[index]
                                              ?.percentage || ""}
                                          </div>
                                        </div>
                                      )}
                                    {"major_subject" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Major Subject{" "}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <select
                                            name="major_subject"
                                            value={academic.major_subject || ""}
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "major_subject",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="" disabled>
                                              Select Major Subject
                                            </option>
                                            {subjects.map((subject) => (
                                              <option
                                                key={subject.id}
                                                value={subject.name}
                                              >
                                                {subject.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]
                                            ?.major_subject || ""}
                                        </div>
                                      </div>
                                    )}
                                    {"position" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>Position</label>
                                          <select
                                            name="position"
                                            value={academic.position || ""}
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "position",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="">
                                              Select Position
                                            </option>
                                            <option value="1st">1st</option>
                                            <option value="2nd">2nd</option>
                                            <option value="3rd">3rd</option>
                                          </select>
                                        </div>
                                        <div className="error-message1">
                                          {academicErrors?.[index]?.position ||
                                            ""}
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_one" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>Elective Subject One</label>
                                          <select
                                            name="elective_subject_one"
                                            value={
                                              academic.elective_subject_one ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_one",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="">
                                              Select Elective Subject One
                                            </option>
                                            {subjects.map((subject) => (
                                              <option
                                                key={subject.id}
                                                value={subject.name}
                                              >
                                                {subject.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_one_total_marks" in
                                      academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Elective Subject One Total Marks
                                          </label>
                                          <input
                                            type="number"
                                            name="elective_subject_one_total_marks"
                                            placeholder="Elective Subject One Total Marks"
                                            value={
                                              academic.elective_subject_one_total_marks ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_one_total_marks",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_one_obtain_marks" in
                                      academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Elective Subject One Obtain Marks
                                          </label>
                                          <input
                                            type="number"
                                            name="elective_subject_one_obtain_marks"
                                            placeholder="Elective Subject One Obtain Marks"
                                            value={
                                              academic.elective_subject_one_obtain_marks ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_one_obtain_marks",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_two" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>Elective Subject Two</label>
                                          <select
                                            name="elective_subject_two"
                                            value={
                                              academic.elective_subject_two ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_two",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="">
                                              Select Elective Subject Two
                                            </option>
                                            {subjects.map((subject) => (
                                              <option
                                                key={subject.id}
                                                value={subject.name}
                                              >
                                                {subject.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_two_total_marks" in
                                      academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Elective Subject Two Total Marks
                                          </label>
                                          <input
                                            type="number"
                                            name="elective_subject_two_total_marks"
                                            placeholder="Elective Subject Two Total Marks"
                                            value={
                                              academic.elective_subject_two_total_marks ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_two_total_marks",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_two_obtain_marks" in
                                      academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Elective Subject Two Obtain Marks
                                          </label>
                                          <input
                                            type="number"
                                            name="elective_subject_two_obtain_marks"
                                            placeholder="Elective Subject Two Obtain Marks"
                                            value={
                                              academic.elective_subject_two_obtain_marks ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_two_obtain_marks",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_three" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>Elective Subject Three</label>
                                          <select
                                            name="elective_subject_three"
                                            value={
                                              academic.elective_subject_three ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_three",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          >
                                            <option value="">
                                              Select Elective Subject Three
                                            </option>
                                            {subjects.map((subject) => (
                                              <option
                                                key={subject.id}
                                                value={subject.name}
                                              >
                                                {subject.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_three_total_marks" in
                                      academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Elective Subject Three Total Marks
                                          </label>
                                          <input
                                            type="number"
                                            name="elective_subject_three_total_marks"
                                            placeholder="Elective Subject Three Total Marks"
                                            value={
                                              academic.elective_subject_three_total_marks ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_three_total_marks",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {"elective_subject_three_obtain_marks" in
                                      academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Elective Subject Three Obtain Marks
                                          </label>
                                          <input
                                            type="number"
                                            name="elective_subject_three_obtain_marks"
                                            placeholder="Elective Subject Three Obtain Marks"
                                            value={
                                              academic.elective_subject_three_obtain_marks ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleAcademicChange(
                                                index,
                                                "elective_subject_three_obtain_marks",
                                                e.target.value
                                              )
                                            }
                                            className="form-control form-control-lg"
                                            required
                                          />
                                        </div>
                                      </div>
                                    )}
                                    {"result" in academic && (
                                      <div className="col-md-4">
                                        <div className="form-outline mt-3">
                                          <label>
                                            Result Attachment{" "}
                                            <span className="text-danger">
                                              {" "}
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="file"
                                            name="result"
                                            placeholder="Result"
                                            accept=".png,.jpeg,.jpg,.pdf"
                                            onChange={(e) => {
                                              const file = e.target.files[0];
                                              if (!file) {
                                                return;
                                              }
                                              if (file.size > 2 * 1024 * 1024) {
                                                showFeedbackModal({
                                                  type: "error",
                                                  title: "Invalid Document",
                                                  message:
                                                    "The selected file is larger than 2 MB.",
                                                  guidance: [
                                                    "Compress the scan or take a clearer photo with a smaller file size.",
                                                    "Accepted formats are PNG, JPEG, JPG, or PDF.",
                                                    "Select the file again after reducing its size.",
                                                  ],
                                                });
                                                e.target.value = "";
                                                return;
                                              }
                                              const reader = new FileReader();
                                              reader.onload = () => {
                                                handleAcademicChange(
                                                  index,
                                                  "result",
                                                  reader.result
                                                );
                                              };
                                              reader.readAsDataURL(file);
                                            }}
                                            className="form-control form-control-lg"
                                            required={!academic.result}
                                          />
                                        </div>
                                        <span className="help-text1">
                                          Upload a clear scan or photo of the
                                          result card. Accepted formats: PNG,
                                          JPEG, JPG, or PDF. Maximum size: 2 MB.
                                          If a document is already attached, you
                                          can view it below or choose a new file
                                          to replace it.
                                        </span>
                                        <div className="error-message1">
                                          {academicErrors?.[index]?.result ||
                                            ""}
                                        </div>
                                        {academic.result !== "" && (
                                          <div className="success-message1">
                                            Result document is already attached.
                                            Click{" "}
                                            <a
                                              href={academic.result}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                color: "#1b5e20",
                                                fontWeight: 600,
                                                textDecoration: "underline",
                                              }}
                                            >
                                              View
                                            </a>{" "}
                                            to preview it, or select a new file
                                            to replace it.
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    <div>
                                      <button
                                        onClick={() =>
                                          handleRemoveQualification(
                                            academic.type
                                          )
                                        }
                                        className="btn-remove"
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                )
                            )}
                          </>
                        </div>
                      )}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 2,
                        pb: 2,
                      }}
                    >
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className="dialog-actions-button negative"
                      >
                        Back
                      </Button>
                      <Button
                        className="dialog-actions-button positive"
                        onClick={handleNext}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                    </Box>
                  </>
                )}
              </Box>
            )}
          </Box>
        </Container>
        {/* Cropper Dialog */}
        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Crop Image</DialogTitle>
          <DialogContent>
            <Cropper
              src={tempImage}
              style={{ height: 400, width: "100%" }}
              aspectRatio={currentField === "applicantImage" ? 1 : NaN} // Fixed ratio for applicantImage
              guides={true}
              onInitialized={(cropperInstance) => setCropper(cropperInstance)} // Corrected instance usage
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              className="dialog-actions-button negative"
            >
              Cancel
            </Button>
            <Button
              onClick={cropImage}
              className="dialog-actions-button positive"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={feedbackModal.open}
          onClose={closeFeedbackModal}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: feedbackModal.type === "success" ? "#2e7d32" : "#c62828",
            }}
          >
            {feedbackModal.type === "success" ? (
              <CheckCircleOutlineIcon />
            ) : (
              <ErrorOutlineIcon />
            )}
            {feedbackModal.title}
          </DialogTitle>
          <DialogContent>
            <Alert
              severity={feedbackModal.type === "success" ? "success" : "error"}
              sx={{ mb: 2 }}
            >
              <AlertTitle>
                {feedbackModal.type === "success" ? "Success" : "Error"}
              </AlertTitle>
              {feedbackModal.message}
            </Alert>
            {feedbackModal.guidance?.length > 0 && (
              <Box>
                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                  {feedbackModal.type === "success"
                    ? "What to do next"
                    : "How to resolve this"}
                </Typography>
                <Box component="ul" sx={{ pl: 2.5, mb: 0 }}>
                  {feedbackModal.guidance.map((item, idx) => (
                    <li key={`${idx}-${item}`}>
                      <Typography variant="body2" sx={{ mb: 0.75 }}>
                        {item}
                      </Typography>
                    </li>
                  ))}
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            {feedbackModal.type === "success" && feedbackModal.voucherToken && (
              <Button
                className="dialog-actions-button positive"
                onClick={() =>
                  window.open(
                    `/admissions/fee-voucher/${feedbackModal.voucherToken}`,
                    "_blank"
                  )
                }
              >
                Open Fee Voucher
              </Button>
            )}
            <Button
              onClick={closeFeedbackModal}
              className={
                feedbackModal.type === "success"
                  ? "dialog-actions-button positive"
                  : "dialog-actions-button negative"
              }
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </DashboardLayout>
  );
};

export default AffiliateApplication;
